'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdPartyMode = function MdPartyMode(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 28.4c4.6 0 8.4-3.8 8.4-8.4 0-0.5-0.1-1.1-0.2-1.6h-3.5c0.1 0.5 0.3 1.1 0.3 1.6 0 2.7-2.3 5-5 5h-6.6c1.5 2 3.9 3.4 6.6 3.4z m0-16.8c-4.6 0-8.4 3.8-8.4 8.4 0 0.5 0.1 1.1 0.2 1.6h3.5c-0.1-0.5-0.3-1.1-0.3-1.6 0-2.7 2.3-5 5-5h6.6c-1.5-2-3.9-3.4-6.6-3.4z m13.4-5c1.8 0 3.2 1.6 3.2 3.4v20c0 1.8-1.4 3.4-3.2 3.4h-26.8c-1.8 0-3.2-1.6-3.2-3.4v-20c0-1.8 1.4-3.4 3.2-3.4h5.4l3-3.2h10l3.1 3.2h5.3z' })
        )
    );
};

exports.default = MdPartyMode;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/party-mode.js
// module id = 1290
// module chunks = 36573943044255 79611799117203 213534597649335